// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section class="box" id="customer-deposit-accounts-create">
    <dynamic-list
      columns="\$ctrl.columns"
      data="\$ctrl.accounts"
      sorting="\$ctrl.sorting"
    >
    </dynamic-list>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/accounts/new-account/new-account-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;